import React from 'react';
import { Row, Col, Input } from 'reactstrap';
import { T } from '../../../traks';

export const UserDetailsForm = ({ updateField, values, errors, isLoading }) => {
  return (
    <React.Fragment>
      <Row className='mb-2'>
        <Col>
          <span className="ad_120_bold"><T>Your details</T></span>
        </Col>
      </Row>
      <Row>
        <Col>
          <label><T>Name *</T></label>
          <Input
            type="text"
            value={values.name}
            onChange={(e) => updateField('name', e.target.value)}
            disabled={isLoading}
          />
          {errors.name && <span className="text-danger form-error">{errors.name}</span>}
        </Col>
      </Row>
      <Row className='mt-2'>
        <Col>
          <label><T>Organization / School</T></label>
          <Input
            type="text"
            value={values.company}
            onChange={(e) => updateField('company', e.target.value)}
            disabled={isLoading}
          />
          {errors.company && <span className="text-danger form-error">{errors.company}</span>}
        </Col>
      </Row>
      {values.company && values.company.length !== 0 && (
        <Row className='mt-2'>
            <Col>
                <label><T>CVR *</T></label>
                <Input
                    type="text"
                    value={values.cvr}
                    onChange={(e) => updateField('cvr', e.target.value)}
                    disabled={isLoading}
                />
                {errors.cvr && <span className="text-danger form-error">{errors.cvr}</span>}
            </Col>
        </Row>
      )}
      <Row className="mt-2">
        <Col>
          <label><T>E-mail address *</T></label>
          <Input
            type="text"
            value={values.email}
            onChange={(e) => updateField('email', e.target.value)}
            disabled={isLoading}
          />
          {errors.email && <span className="text-danger form-error">{errors.email}</span>}
        </Col>
      </Row>
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/c/PremiumKeys/Checkout/UserDetailsForm.js